import { Routes } from "@angular/router";
import { AdminComponent } from "app/admin/component/admin/admin.component";
import { LayoutComponent } from "app/shared/components/layout/layout.component";
import { MsalGuard } from '@azure/msal-angular';
import { AdminGuard } from "../shared/services/admin-guard.service";

export const ADMIN_ROUTES: Routes = [
    {
        path: 'admin',
        component: LayoutComponent,
        canActivate: [MsalGuard,AdminGuard],
        children: [
            { path: '', component: AdminComponent }
        ]
    }
];
